export function submitAddCustomReportDataCustomer()
{
    return({
        type:"SUBMIT_ADD_CUSTOM_REPORT_DATA_CUSTOMER"
    })
}